export default __webpack_public_path__ + "static/media/icon_pedidos_composicao_laudos.2652cf0e.svg";